document.addEventListener('DOMContentLoaded', function() {
  // Get the header wrapper element
  const headerWrapper = document.querySelector('m-header.m-header>.m-header__wrapper');
  const mainBody = document.querySelector('body')
  if (!headerWrapper) {
    console.warn('Header wrapper element m-header.stuck .m-header__wrapper not found.');
    return; // Exit if element is not found
  }

  // Get the close button element
  const closeButton = document.querySelector('.m-announcement-bar__close');
  if (!closeButton) {
    console.warn('Close button element with class "m-announcement-bar__close" not found.');
    return; // Exit if close button is not found
  }

  // Add click event listener to the close button
  closeButton.addEventListener('click', function(event) {
    event.preventDefault(); // Prevent default action of the click, if needed
    // Reset the top style of the header wrapper to 0px
    headerWrapper.style.top = '0px';
    mainBody.style.paddingTop = '0px'
  });
});